import fabric from '@/lib/fabric';

export interface ShadowValues {
  enabled: boolean;
  color: string;
  blur: number;
  offsetX: number;
  offsetY: number;
}

const DEFAULTS: ShadowValues = {
  enabled: false,
  color: 'rgba(0,0,0,0.35)',
  blur: 8,
  offsetX: 4,
  offsetY: 4,
};

function shadowColorToHex(color: string): string {
  if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(color)) {
    return color.length === 4
      ? `#${color[1]}${color[1]}${color[2]}${color[2]}${color[3]}${color[3]}`
      : color;
  }
  const m = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
  if (m) {
    const hex = (n: string) => Number(n).toString(16).padStart(2, '0');
    return `#${hex(m[1])}${hex(m[2])}${hex(m[3])}`;
  }
  return '#000000';
}

export function readObjectShadow(obj: fabric.Object): ShadowValues {
  const shadow = obj.shadow as fabric.Shadow | null | undefined;
  if (!shadow) return { ...DEFAULTS, enabled: false };
  return {
    enabled: true,
    color: shadowColorToHex(String(shadow.color || '#000000')),
    blur: Math.round(shadow.blur || 0),
    offsetX: Math.round(shadow.offsetX || 0),
    offsetY: Math.round(shadow.offsetY || 0),
  };
}

export function applyObjectShadow(
  obj: fabric.Object,
  values: Partial<ShadowValues>
): ShadowValues {
  const current = readObjectShadow(obj);
  const next: ShadowValues = { ...current, ...values };

  if (!next.enabled) {
    obj.shadow = undefined;
    return { ...DEFAULTS, enabled: false };
  }

  obj.set(
    'shadow',
    new fabric.Shadow({
      color: next.color,
      blur: Math.max(0, next.blur),
      offsetX: next.offsetX,
      offsetY: next.offsetY,
    })
  );
  return next;
}
